import { Image } from '@lt/components';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectBonuseNotice } from 'src/routes/Checkout/store/selectors/order';
import {
  getCashbackIconPng,
  getCashbackIconWebp,
} from 'src/store/cashback/selectors';
import styles from './CashbackNotice.module.css';

const CashbackNotice = () => {
  const webpIcon = useSelector(getCashbackIconWebp);
  const pngIcon = useSelector(getCashbackIconPng);
  const bonuseNotice = useSelector(selectBonuseNotice);

  if (!bonuseNotice) return null;

  return (
    <div className={styles.container}>
      <Image src={webpIcon} fallback={pngIcon} className={styles.icon} />
      <span>{bonuseNotice}</span>
    </div>
  );
};

export default CashbackNotice;
